import { CurricularUnitService } from 'data/services';
import { CurricularUnitServiceInterface } from 'domain/services';
import { makeGetAllCurricularUnitsUser } from 'main/factories/usecases/curricular-units/remote-get-all-curricular-units-user-factory';

export const makeCurricularUnitService = (): CurricularUnitServiceInterface => {
  return new CurricularUnitService(makeGetAllCurricularUnitsUser());
};
